<template>
  <div id="app">
    <p>Welcome to your Vue.js app!</p>

    <dropzone id="vueDropzone" url="http://192.168.99.100:8080/api/uploadFile" :useFontAwesome="true" v-on:vdropzone-success="showSuccess">
        <!-- Optional parameters if any! -->
        <input type="hidden" name="token" value="xxx">
    </dropzone>
  </div>
</template>

<script>
import Dropzone from 'vue2-dropzone'

export default {
  name: 'vue-dropzone',
  components: {
    Dropzone
  },
  methods: {
    showSuccess (file) {
      console.log(file)
      console.log('A file was successfully uploaded')
    }
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?381356b0